module.exports = __webpack_public_path__ + "static/img/11.92ba943.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/11.png
// module id = fbOI
// module chunks = 1